import "core-js/modules/esnext.iterator.constructor.js";
import "core-js/modules/esnext.iterator.for-each.js";
import { handleHttp, setImgsize, locationHandle, loadScript } from "@/utils/utils";
import Swiper from 'swiper';
import 'swiper/css/swiper.css';
export default {
  data() {
    return {
      linkcontainerflag: false,
      iframeurl: '',
      linklabel: {},
      timer: null
    };
  },
  watch: {
    '$attrs.detail.banner'(val) {
      if (val) {
        this.swiperEl = new Swiper(this.$refs.swipercontainer, {
          initialSlide: 0,
          pagination: {
            el: this.$refs.swiperpage
          },
          autoplay: true,
          observeSlideChildren: true,
          observeParents: true,
          observer: true
        });
      }
    },
    '$attrs.pointStruct'(val) {
      this.linklabel = {};
      val.forEach(item => {
        this.linklabel[item.alias] = item.label;
      });
    },
    '$attrs.detail.introduce'(val) {
      if (val) {
        /* MultiEditor存在 */
        this.timer = setInterval(() => {
          if (MultiEditor !== undefined) {
            clearInterval(this.timer);
            MultiEditor.init('detail', null, {
              attachMode: 'preview',
              largePreview: 'largePreview'
            });
            MultiEditor.renderRichtext('editor1', val);
          }
        }, 500);
      }
    }
  },
  created() {
    loadScript('https://noteyd.chaoxing.com/res/plugin/ueditor4thirdparty/multieditor.js');
  },
  methods: {
    // 统一换地址
    sethandleHttp(item) {
      return setImgsize(item, 488, 248);
    },
    // 切换音视频
    showType(val) {
      this.$attrs.detail.currentShowtype = val;
      if (val !== 'banner') {
        this.$api.getUrlByObjectId(this.$attrs.detail[val][0].objectId).then(res => {
          let currenthttp = location.protocol;
          this.$attrs.detail[val + 'url'] = res.http;
        });
      } else {
        this.$refs.videoItem.pause();
        this.$refs.audioItem.pause();
      }
    },
    // 关闭事件
    closePop() {
      this.$emit('closeHandle');
      this.popshowflag = false;
    },
    // 返回事件
    goback() {
      this.linkcontainerflag = false;
      this.iframeurl = '';
    },
    goLocation(url) {
      locationHandle.call(this, this.$attrs.detail, url);
    },
    // 跳转
    goLink(url) {
      // 若选择打开新窗口处理
      if (this.$attrs.detail.linkTarget !== undefined && this.$attrs.detail.linkTarget === '是') {
        window.open(url);
      } else {
        this.linkcontainerflag = true;
        this.iframeurl = url;
      }
    }
  }
};